import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_CHANGE_ORDER]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_CHANGE_ORDER]: (state, item) => removeItem(state, item)
}
